import { emojis, vibeIcons } from '../constants'

export const getVibeIcon = (givenVibe) => {
  if (!givenVibe) {
    return emojis.NEUTRAL
  }
  const roundedVibe = Math.round(givenVibe)
  return vibeIcons[roundedVibe - 1]
}
